import { isLogoOnlyArtwork, isSchoolCloneTemplate, type TemplateLike } from './store-template-kinds';

export const KNOWN_BRAND_LINEUPS = ['nike-only', 'adidas-only', 'under-armour-only'] as const;

export function isBrandLineup(id: string): boolean {
  return (KNOWN_BRAND_LINEUPS as readonly string[]).includes(String(id || '').trim());
}

// Template-tab save payload. sport-general / generic / empty → logo-only.
export function artworkPatchFromSelection(id: string): {
  artworkTemplateId: string;
  useDesignTemplates: boolean;
} {
  const trimmed = String(id || '').trim();
  if (!trimmed || trimmed === 'logo-only' || trimmed === 'none') {
    return { artworkTemplateId: '', useDesignTemplates: false };
  }
  return {
    artworkTemplateId: trimmed,
    useDesignTemplates: !isLogoOnlyArtwork(trimmed),
  };
}

export function currentProductSelection(store: { productTemplateId?: string }): string {
  return store.productTemplateId || 'general';
}

export function currentArtworkSelection(store: {
  artworkTemplateId?: string;
  sportTemplateId?: string;
  useDesignTemplates?: boolean;
}): string {
  if (store.useDesignTemplates === false && !store.artworkTemplateId) return 'logo-only';
  return store.artworkTemplateId || store.sportTemplateId || 'logo-only';
}

export function currentFrameSelection(store: { sportTemplateId?: string }): string {
  return store.sportTemplateId || 'generic';
}

export function artworkAllowedForProduct(productId: string, artworkId: string): boolean {
  if (isLogoOnlyArtwork(artworkId) || artworkId === 'logo-only' || !artworkId) return true;
  return !isBrandLineup(productId);
}

export function suggestArtworkForProduct<T extends TemplateLike>(
  productId: string,
  templates: T[],
): string {
  if (!isBrandLineup(productId)) return 'logo-only';
  const general = templates.find((t) => t.id === 'sport-general');
  return general?.id || 'logo-only';
}

export function artworkOptionsForProduct<T extends TemplateLike>(
  productId: string,
  templates: T[],
  keepId?: string,
): T[] {
  const keep = String(keepId || '');
  return templates.filter((t) => {
    if (!t.id) return false;
    if (isSchoolCloneTemplate(t) && t.id !== keep) return false;
    if (isBrandLineup(productId)) return isLogoOnlyArtwork(t.id) || t.id === keep;
    return true;
  });
}

export function templatesPatchFromSelection(input: {
  productTemplateId: string;
  artworkTemplateId: string;
  sportType?: string;
  gender?: string;
  sportTemplateId?: string;
}): {
  productTemplateId: string;
  artworkTemplateId: string;
  useDesignTemplates: boolean;
  sportType?: string;
  gender?: string;
  sportTemplateId?: string;
} {
  const art = artworkPatchFromSelection(input.artworkTemplateId);
  return {
    productTemplateId: String(input.productTemplateId || 'general').trim() || 'general',
    ...art,
    ...(input.sportType !== undefined ? { sportType: input.sportType } : {}),
    ...(input.gender !== undefined ? { gender: input.gender } : {}),
    ...(input.sportTemplateId !== undefined ? { sportTemplateId: input.sportTemplateId } : {}),
  };
}
